<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <h4 class="earth-color">Inactive Activities</h4>
      <v-spacer></v-spacer>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="search"
        class="futuristic-search"
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="columns"
      :items="inActiveInventory"
      :search="search"
      :rows-per-page-items="[10, 25, { 'text': 'All', 'value': -1 }]"
      :disable-initial-sort="true"
      :loading="$loadingTrue"
      class="futuristic-table"
    >
      <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <td>{{ props.item.code }}</td>
        <td>{{ props.item.sub_code }}</td>
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.maximum_guests }}</td>
        <td class="text-right">
          <v-btn
            :depressed="true"
            color="primary"
            class="futuristic-btn"
            @click="makeActive(props.item.public_id)"
          >Make Active</v-btn>
        </td>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search: '',
      columns: [
        {
          text: 'Code',
          value: 'code'
        },
        {
          text: 'Sub Code',
          value: 'sub_code'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Maximum Guests',
          value: 'maximum_guests'
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('get_in_active_activities')
  },
  methods: {
    makeActive: function (publicId) {
      this.$store.dispatch('make_activity_active', publicId)
    },
    viewUser: function (publicId) {
      this.$router.push({
        name: 'SingleInventory',
        params: {
          inventory_id: publicId
        }
      })
    }
  }
}
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
}

.earth-color {
  color: #4caf50;
  font-weight: 600;
  margin: 0;
}

/* Futuristic Search */
.futuristic-search {
  max-width: 250px;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

/* Futuristic Buttons */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Futuristic Table */
.futuristic-table {
  border-radius: 8px;
  margin: 0 8px 8px;
}

.futuristic-table >>> table {
  border-collapse: separate;
  border-spacing: 0;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #4caf50;
  font-weight: 600;
  font-size: 13px;
}

.futuristic-table >>> tbody tr {
  transition: background-color 0.2s ease;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f5f7fa;
}

/* Futuristic Alert */
.futuristic-alert {
  border-radius: 8px;
  margin: 8px;
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
  }

  .futuristic-search {
    max-width: 100%;
    margin-top: 12px;
  }

  .futuristic-table {
    margin: 0 4px 4px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-table >>> tbody tr td {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .futuristic-table {
    margin: 0 4px 4px;
    overflow-x: auto;
  }

  .futuristic-table >>> table {
    min-width: 600px; /* Ensure table is wide enough for all 5 columns */
  }

  .futuristic-table >>> thead {
    display: table-header-group;
  }

  .futuristic-table >>> tbody tr {
    display: table-row;
  }

  .futuristic-table >>> tbody tr td {
    display: table-cell;
    font-size: 0.85rem;
    padding: 6px 8px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 0.85rem;
    padding: 6px 8px;
  }
}
</style>